// eslint-disable-next-line import/no-anonymous-default-export
export default /* glsl */`

// good idea but it seems that the javascript object reference became bit of a burden
// struct BoxProjectionData {
//   bool useBoxProjection;
//   vec3 size;
//   vec3 position;
// };

// uniform BoxProjectionData boxProjectionData;


uniform bool useBoxProjection;
uniform vec3 boxProjectionSize;
uniform vec3 boxProjectionPosition;

// gets the given position relative to the cube size
vec3 getNormalizedPosition(vec3 cubeSize, vec3 cubePos, vec3 vWorldPosition){
  vec3 adjustedPosition = vWorldPosition - cubePos;
  vec3 normalizedCoords = vec3(
    adjustedPosition.x / cubeSize.x,
    adjustedPosition.y / cubeSize.y,
    adjustedPosition.z / cubeSize.z
  );
  return normalizedCoords;
}

  vec3 parallaxCorrectedNormal( vec3 v, vec3 cubeSize, vec3 cubePos, vec3 vWorldPosition ) {
    vec3 nDir = normalize( v );
    vec3 rbmax = ( .5 * cubeSize + cubePos - vWorldPosition ) / nDir;
    vec3 rbmin = ( -.5 * cubeSize + cubePos - vWorldPosition ) / nDir;
    vec3 rbminmax;
    rbminmax.x = ( nDir.x > 0. ) ? rbmax.x : rbmin.x;
    rbminmax.y = ( nDir.y > 0. ) ? rbmax.y : rbmin.y;
    rbminmax.z = ( nDir.z > 0. ) ? rbmax.z : rbmin.z;
    float correction = min( min( rbminmax.x, rbminmax.y ), rbminmax.z );
    vec3 boxIntersection = vWorldPosition + nDir * correction;
    return boxIntersection - cubePos;
  }
`;